import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { TableFilterEvent, TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ReportsService } from "../../../../core/services/reports.service";
import FileSaver from "file-saver";
import { OrdersInvoicedDetailsRequest } from "../../../../core/models/reports/orderBilledInvoiceDetailsRequestDto";
import { OrdersInvoicedDetailsResponse } from "../../../../core/models/reports/ordersInvoicedDetailsResponse";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";

@Component({
  selector: "jni-order-billed-invoiced-details",
  templateUrl: "./order-billed-invoiced-details.component.html",
  styleUrls: ["./order-billed-invoiced-details.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    DateFilterComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
  ],
})
export class OrderBilledInvoicedDetailsComponent implements OnInit {
  orderDisplayModal = false;
  clientDisplayModal = false;
  vendorDisplayModal = false;
  clientId = "";
  saleOrderId = "";
  vendorAccountNumber = "";
  @Output() closeModalEvent = new EventEmitter();
  @Input() showTotalSell = true;
  @Input() isModal = false;

  ordersInvoicedDetailsDetailLists: OrdersInvoicedDetailsResponse[] = [];
  filterOrdersInvoicedDetailsDetailLists: OrdersInvoicedDetailsResponse[] = [];
  filteredDataOrdersInvoicedDetailsDetailLists: OrdersInvoicedDetailsResponse[] =
    [];
  invoiceDateColumn = "invoiceDate";
  @Input() ordersInvoicedDetailsRequest: OrdersInvoicedDetailsRequest =
    {} as OrdersInvoicedDetailsRequest;

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private _dashboardService: DashboardService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.getOrdersWrittenReportDetail();
  }

  getOrdersWrittenReportDetail() {
    this._loaderService.setLoaderState(true);
    const req = this.ordersInvoicedDetailsRequest ?? {};
    const obj: OrdersInvoicedDetailsRequest = {
      isAdditionalFilters: req.isAdditionalFilters ?? false,
      customerAccountD365: req.customerAccountD365 ?? "",
      invoiceDateFrom: req.invoiceDateFrom ?? null,
      invoiceDateTo: req.invoiceDateTo ?? null,
    };

    this._reportsService.ordersInvoicedDetail(obj).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.ordersInvoicedDetailsDetailLists = res.data;
          this.filterOrdersInvoicedDetailsDetailLists = res.data;
          this.filteredDataOrdersInvoicedDetailsDetailLists = res.data;
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  // onInvoiceDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.ordersInvoicedDetailsDetailLists.filter((x) =>
  //       x.invoiceDate?.includes(event.target.value)
  //     );
  //     this.filterOrdersInvoicedDetailsDetailLists = filterList;
  //   } else {
  //     this.filterOrdersInvoicedDetailsDetailLists =
  //       this.ordersInvoicedDetailsDetailLists;
  //   }
  // }

  getInvoiceReport(invoiceId: string) {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getInvoiceReport(invoiceId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  exportExcelFile() {
    this.exportExcelForFilterData(
      this.filteredDataOrdersInvoicedDetailsDetailLists
    );
  }

  redirectToSaleorder(saleorder: string) {
    //const url = `/orders/order-summary/${saleorder}`;
    //this.route.navigate([url]);
    if (saleorder) {
      this.saleOrderId = saleorder;
      this.orderDisplayModal = true;
    }
  }

  redirectToClient(client: string) {
    //const url = `/clients/active/client-details/${client}`;
    //this.route.navigate([url]);
    if (client) {
      this.clientId = client;
      this.clientDisplayModal = true;
    }
  }

  exportExcelForFilterData(filterclientlist: OrdersInvoicedDetailsResponse[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Invoice#"]: datum.invoiceNumber,
        ["Invoice Date"]: new Date(datum.invoiceDate),
        ["Client"]: datum.customer,
        ["Sale Order #"]: datum.salesOrderNumber,
        ["Client PO"]: datum.customerPO,
        ["Job Name"]: datum.jobName,
        ["Total Sell"]:
          this.showTotalSell === true ? datum.totalSell : datum.subTotalAmount,
        ["Base Comm"]: datum.baseCommission,
        ["Order GP%"]: datum.orderGPPercentage,
        ["Billed Freight"]: datum.billedFreight,
        ["Billed Tax"]: datum.billedTax,
        ["Invoice Total"]: datum.billedTotal,
        ["Prepay"]: datum.prepay,
        ["Invoice Balance"]: datum.balance,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrdersBilledInvoiceDetailReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModal() {
    this.vendorDisplayModal = false;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  clearFilter(event: OrdersInvoicedDetailsResponse[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterOrdersInvoicedDetailsDetailLists = event;
    }
  }

  applyFilter(event: OrdersInvoicedDetailsResponse[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterOrdersInvoicedDetailsDetailLists = event;
    }
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length > 0) {
      this.filteredDataOrdersInvoicedDetailsDetailLists = event.filteredValue;
    } else {
      this.filteredDataOrdersInvoicedDetailsDetailLists =
        this.filterOrdersInvoicedDetailsDetailLists;
    }
  }

  closeModalEventFunction() {
    this.closeModalEvent.emit();
  }
}
